import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "USER_DASHBOARD", {
  DELETED: "User deleted succesfully",
  CREATED: "User created succesfully",
  EDITED: "User edited succesfully",
});
